import React, { useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';

import { makeGetTaskTitleIdentifier } from '../../../../../redux/tasks/taskEntities/selectors';
import { openTaskAction } from '../../../../../redux/tasks/actions';

const ConnectedTaskTitleIdentifier = ({ onClick, taskId, titleIdentifier, notAligned }) => {
  const dispatch = useDispatch();
  
  const handleClick = useCallback(async () => {
    if (typeof onClick === 'function') {
      onClick(taskId);
      return;
    }

    dispatch(openTaskAction(true, titleIdentifier, taskId));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId, titleIdentifier]);

  return (
    <div className={`task-identifier text-xs ${notAligned ? '' : 'text-center'}`} onClick={handleClick}>
      {titleIdentifier}
    </div>
  );
}

const makeMapStateToProps = () => {
  const getTaskTitleIdentifier = makeGetTaskTitleIdentifier();
  return (state, props) => ({
    titleIdentifier: getTaskTitleIdentifier(state, props),
  });
};

export default connect(makeMapStateToProps)(ConnectedTaskTitleIdentifier);
